import CollaborateursTab from "@features/rh/collaborateurs/components/CollaborateursTab";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Users } from "lucide-react";

export const Route = createFileRoute("/_app/rh/collaborateurs/")({
  loader: requirePermission(PERMISSIONS.RH.EMPLOYES.VIEW),
  staticData: {
    title: "Collaborateurs",
    icon: Users,
    tab_icon: Users,
    permission: PERMISSIONS.RH.EMPLOYES.VIEW,
    module: "rh",
    section: "Ressources Humaines",
    order: 20,
    showInNav: true,
    showInTab: true,
    showInBreadcrumb: true,
    description: "Gestion des collaborateurs",
  },
  component: CollaborateursTab,
});
